import { type Configuration, LogLevel } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID ?? '';
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID ?? '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    // Always redirect to app root — safer than keeping the requested URL
    // which can carry the #code fragment and confuse MSAL on retry.
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: `${window.location.origin}/`,
    // CRITICAL: false prevents MSAL from re-navigating after handling the
    // redirect, which in dev with HMR can trigger a reload loop.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // localStorage survives page reloads AND across tabs.
    // sessionStorage would be safer but doesn't work in PWA standalone mode.
    cacheLocation: 'localStorage',
    // Set to true if users hit issues in Safari (3rd-party cookie blocking).
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_level, message, containsPii) => {
        if (containsPii) return;
        if (import.meta.env.DEV) {
          console.debug('[MSAL]', message);
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

export const graphScopes = {
  default: ['User.Read'],
  users: ['User.Read.All'],
  directory: ['Directory.Read.All'],
  organization: ['Organization.Read.All'],
  sharePoint: ['Sites.ReadWrite.All'],
  mail: ['Mail.Send'],
  files: ['Files.ReadWrite.All'],
};
